export const calculateSociometry = (submissions, currentClassStudents = []) => {
  // PUANLAMA SİSTEMİ
  const POINTS = { 1: 3, 2: 2, 3: 1 };
  const COLORS = { 1: "#ef4444", 2: "#3b82f6", 3: "#000000" }; // Red, Blue, Black

  const scores = {};       
  const incoming = {};     
  const outgoing = {};     
  const nodes = [];        
  const links = [];        

  const distinctStudents = new Set();

  // 1. HAYALET ÇOCUK KORUMASI: Varsa önce tüm kayıtlı öğrencileri ekle
  if (Array.isArray(currentClassStudents)) {
    currentClassStudents.forEach(stu => distinctStudents.add(stu.studentNo?.toString() || stu.no?.toString()));
  }

  // Anketi dolduranları ve seçilenleri de garanti olsun diye ekle
  submissions.forEach(s => {
    distinctStudents.add(s.studentNo.toString());
    if(s.answers) {
       Object.values(s.answers).forEach(val => {
         if(val && val.includes('-')) distinctStudents.add(val.split('-')[0].trim());
       });
    }
  });

  // Başlangıç değerlerini sıfırla
  distinctStudents.forEach(no => {
    if(!no) return;
    scores[no] = 0;
    incoming[no] = [];
    outgoing[no] = [];
  });

  // 2. Cevapları Tara ve Puanla
  submissions.forEach(sub => {
    const source = sub.studentNo.toString();

    if (sub.answers) {
      Object.keys(sub.answers).forEach(key => {
        const parts = key.split('_');
        if (parts.length === 2) {
          const rank = parseInt(parts[1]); 
          const rawVal = sub.answers[key]; 

          if (rawVal && rawVal.includes('-')) {
            const target = rawVal.split('-')[0].trim(); 

            // EGO/NARSİZM KORUMASI: Kendini seçemez!
            if (source === target) return; 

            if (scores[target] !== undefined) {
              scores[target] += POINTS[rank] || 0;
            } else {
               scores[target] = POINTS[rank] || 0; 
            }

            links.push({
              source: source,
              target: target,
              rank: rank,
              color: COLORS[rank] || "#ccc",
              isMutual: false 
            });

            if(incoming[target]) incoming[target].push(source);
            if(outgoing[source]) outgoing[source].push(target);
          }
        }
      });
    }
  });

  // 3. Karşılıklı Çekimleri (Mutual) Bul
  let mutualCount = 0;
  const mutualPairs = [];
  
  links.forEach(link => {
    const isMutual = links.find(l => l.source === link.target && l.target === link.source);
    if (isMutual) {
      link.isMutual = true;
      link.width = 2; 
      const pairId = [link.source, link.target].sort().join('-');
      if(!mutualPairs.includes(pairId)) {
        mutualPairs.push(pairId);
        mutualCount++;
      }
    } else {
      link.width = 1; 
    }
  });

  // 4. Kategorileri Belirle
  const sortedStudents = Object.entries(scores)
    .map(([no, score]) => ({ no, score }))
    .sort((a, b) => b.score - a.score);

  const maxScore = sortedStudents.length > 0 ? sortedStudents[0].score : 1;
  const avgScore = sortedStudents.reduce((acc, curr) => acc + curr.score, 0) / (sortedStudents.length || 1);

  const leaders = sortedStudents.filter(s => s.score > avgScore * 1.5).map(s => s.no); 
  const loners = sortedStudents.filter(s => s.score === 0).map(s => s.no); 
  
  // Çekimserler/Devamsızlar Ayrımı
  const abstainers = [];
  const absentees = [];
  Object.keys(outgoing).forEach(no => {
     if(outgoing[no].length === 0) absentees.push(no); // Hiç seçim yapmamış (Muhtemelen ankete katılmadı)
     else if(outgoing[no].length < 3) abstainers.push(no); // Az seçim yapmış
  });

  // 5. Görsel Düğümleri Hazırla (Altın Açı ile Kusursuz Dağılım)
  sortedStudents.forEach((stu, index) => {
    // Görsel yığılmayı önleyen doğanın Altın Açısı (Golden Angle: ~137.5 derece)
    const angle = index * 2.39996; 
    
    const maxRadius = 280;
    const radius = maxScore > 0 ? ((maxScore - stu.score) / maxScore) * maxRadius : maxRadius;

    // Radius'a küçük organik bir sapma (jitter) ekleyerek düğümlerin tam üst üste binmesini önlüyoruz
    const jitter = (Math.random() - 0.5) * 20; 
    const finalRadius = Math.max(0, Math.min(maxRadius, radius + jitter));

    nodes.push({
      id: stu.no,
      label: stu.no,
      score: stu.score,
      x: Math.cos(angle) * finalRadius,
      y: Math.sin(angle) * finalRadius,
      category: leaders.includes(stu.no) ? 'Lider' : (loners.includes(stu.no) ? 'Yalnız' : 'Normal')
    });
  });

  // 6. Rapor Metni
  let reportText = `Sosyometri analizi sonuçlandırılmıştır. Ankete ${submissions.length} öğrenci katılmıştır.\n\n`;
  
  reportText += `👑 LİDERLER (En Çok Tercih Edilenler):\n${leaders.length > 0 ? leaders.join(', ') : 'Belirgin bir lider çıkmadı.'}\n\n`;
  reportText += `🥀 YALNIZLAR (Hiç Seçilmeyenler / Risk Grubu):\n${loners.length > 0 ? loners.join(', ') : 'Sınıfta tamamen dışlanan öğrenci bulunmadı.'}\n\n`;
  reportText += `🔗 GRUP BÜTÜNLÜĞÜ:\nToplam ${mutualCount} adet karşılıklı (mutual) ilişki tespit edildi. `;
  if(mutualCount < sortedStudents.length / 2) reportText += "Grup içi etkileşim zayıf görünüyor, klikleşmeler veya kopukluklar olabilir.";
  else reportText += "Sınıf içi iletişim ve etkileşim güçlü.";

  // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  // Sosyometri bir "Sınıf/Grup" testidir. Sınıfın sosyal riskini, 
  // gruptaki 'Yalnız' (Dışlanmış) öğrenci yüzdesiyle belirliyoruz.
  const lonerRatio = sortedStudents.length > 0 ? (loners.length / sortedStudents.length) : 0;
  
  let masterRisk = "low";
  if (lonerRatio >= 0.20) masterRisk = "high"; // Sınıfın %20'si dışlanmışsa ciddi bir klikleşme veya zorbalık riski vardır
  else if (lonerRatio >= 0.10) masterRisk = "medium";

  return {
    // 1. Ortak Dil (Sınıf Radarı okuyacak)
    riskScore: Math.round(lonerRatio * 100), // Sınıftaki dışlanma/yalnızlık yüzdesi
    masterRisk: masterRisk,
    isCritical: false, // Sosyal izolasyon tehlikelidir ama acil kriz (18. madde) değildir
    domain: "social", // Sosyal/Grup dinamiği

    // 2. Mevcut Detaylı Veriler (Dokunmadık, Sosyogram Çizimi İçin Gerekenler)
    nodes,
    links,
    leaders,
    loners,
    abstainers,
    absentees,
    mutualCount,
    text: reportText,
    chartData: sortedStudents.slice(0, 10).map(s => ({ subject: s.no, A: s.score, fullMark: maxScore }))
  };
};